class EventBus {
    constructor() {
        this.events = new Map();
    }
    subscribe(event, callback) {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event).add(callback);
        return () => {
            const callbacks = this.events.get(event);
            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) {
                    this.events.delete(event);
                }
            }
        };
    }
    publish(event, data, source) {
        const payload = {
            type: event,
            data,
            timestamp: Date.now(),
            source,
        };
        const callbacks = this.events.get(event);
        if (callbacks) {
            callbacks.forEach((callback) => {
                try {
                    callback(payload);
                }
                catch (error) {
                    console.error(`Error in event callback for "${event}":`, error);
                }
            });
        }
    }
    clear() {
        this.events.clear();
    }
    getSubscriberCount(event) {
        return this.events.get(event)?.size || 0;
    }
    getEventNames() {
        return Array.from(this.events.keys());
    }
}
export const eventBus = new EventBus();
